import React from 'react';
import { SPLIT_CONTAINER_MARGIN_HORIZONTAL } from '@/styles';
import { StyleSheet, View } from 'react-native';

interface Props {
  children: React.ReactNode;
  FilterComponent: React.ReactNode;
  filtersVisible?: boolean;
}

export const SplitFilterContainer: React.FC<Props> = ({
  children,
  FilterComponent,
  filtersVisible,
}) => {
  if (!filtersVisible) {
    return <>{children}</>;
  }
  return (
    <View style={styles.base}>
      <View style={styles.filter}>{FilterComponent}</View>
      <View style={styles.primaryComponent}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    flex: 1,
    flexDirection: 'row',
  },
  filter: {
    height: '100%',
    marginLeft: SPLIT_CONTAINER_MARGIN_HORIZONTAL,
    width: 196,
  },
  primaryComponent: {
    flex: 1,
  },
});
